import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import NavigationBar from '../../components/Navigationbar/Navigationbar';
import { post, Token } from '../../Script/Session';
import Headline from '../../components/headline/Headline';
import { Box, Button, Link, Table, Typography } from '@mui/joy';
import { Card, CardContent } from '@mui/joy';
import {
  Input,
  Checkbox,
  FormControl,
  FormLabel,
  Textarea
} from '@mui/joy';

function MyProfile() {
  const { id } = useParams();
  const [data, setdata] = useState();
  const navigate = useNavigate();
  const [wit, setWit] = useState("90.5%");
  useEffect(() => {
    let body = {};
    body.token = Token.get();
    body.action = "get";
    body.type = id == "--" ? "own" : id;
    let response = post(body, "/profil");
    if (response == "LOGOUT") {
      navigate("/");
    }
    setdata(JSON.parse(response));
  }, []);
  const [geburtztag, setGeburtztag] = useState(null);
  const [telefon, setTelefon] = useState("");
  const [beruf, setBeruf] = useState("");
  const [fax, setFax] = useState("");
  const [web, setWeb] = useState("");
  const [qualifikation, setQualifikation] = useState("");
  const [vermoegenhp, setVermoegenhp] = useState("");
  const [vermoegenhpsumme, setVermoegenhpsumme] = useState("");
  const [vermittlerregnummer, setVermittlerregnummer] = useState("");
  const [finanzvermittlernummer, setFinanzvermittlernummer] = useState("");
  const [aufsichtsbehoerde, setAufsichtsbehoerde] = useState("");
  const [identifikationsnummer, setIdentifikationsnummer] = useState("");
  const [bafin, setBafin] = useState(false);
  const [ombudsman, setOmbudsman] = useState(false);
  const [ombudsmannpkw, setOmbudsmannpkw] = useState(false);
  const [zentralregister, setZentralregister] = useState(false);
  const [freitext, setFreitext] = useState("");
  const [editmode, seteditmode] = useState(false);
  function putedit() {
    setGeburtztag(data.geburtztdatumaslong);
    setTelefon(data.tel);
    setBeruf(data.beruf);
    setFax(data.fax);
    setWeb(data.website);
    setQualifikation(data.qualifikation);
    setVermoegenhp(data.vermögenshp);
    setVermoegenhpsumme(data.vermögenshpsumme);
    setFinanzvermittlernummer(data.finanzvermittlernummer);
    setVermittlerregnummer(data.vermittlerregnummer);
    setAufsichtsbehoerde(data.aufsichtsbehörde);
    setIdentifikationsnummer(data.identifikationsnummer);
    setBafin(data.bafin);
    setOmbudsman(data.ombudsman);
    setOmbudsmannpkw(data.ombudsmanpkw);
    setZentralregister(data.zentralregister);
    setFreitext(data.eufreitext);
    seteditmode(true);
  }

  function save() {
    let body = {};
    body.token = Token.get();
    body.action = "update";
    body.type = id == "--" ? "own" : id;
    body.geburtztag = geburtztag;
    body.tel = telefon;
    body.beruf = beruf;
    body.fax = fax;
    body.web = web;
    body.qual = qualifikation;
    body.vermögenhp = vermoegenhp;
    body.vermögenhpsumme = vermoegenhpsumme;
    body.vermittlerregnummer = vermittlerregnummer;
    body.finanzvermittlernummer = finanzvermittlernummer;
    body.aufsichtsbehörde = aufsichtsbehoerde;
    body.identifikationsnummer = identifikationsnummer;
    body.bafin = bafin;
    body.ombudsman = ombudsman;
    body.ombudsmannpkv = ombudsmannpkw;
    body.zentralregister = zentralregister;
    body.freitext = freitext;
    let response = post(body, "/profil");
    if (response == "LOGOUT") {
      navigate("/");
    }
    window.location.reload();
  }



  if (!data) {
    return (<Typography>Loading...</Typography>)
  }
  return (
    <>
      <Box
        sx={{
          width: wit,
          position: "fixed",
          top: 0,
          right: 0,
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          bgcolor: "background.body",
          borderLeft: "1px solid",
          borderColor: "divider",
          overflowY: "auto",
        }}
      >
        <Headline title={"Profil"} />

        <Box sx={{ width: "98%", p: 2, display: "flex" }}>
          {
            !editmode && (
              <Card variant='soft' sx={{ mt: 2 }}>
                <Typography level="title-md">{data.nachname} {data.vorname}</Typography>
                <Table>
                  <thead>
                    <tr>
                      <th>Informationen</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Name</td>
                      <td>{data.nachname} {data.vorname}</td>
                    </tr>
                    {
                      data.beruf != "" && (
                        <tr>
                          <td>Beruf</td>
                          <td>{data.beruf}</td>
                        </tr>
                      )
                    }
                    <tr>
                      <td>Mitgliedschaft im Verein</td>
                      <td>{data?.istmitglied ? "Ja" : "Nein"}</td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>{data.email}</td>
                    </tr>
                    {
                      data.firmen.length > 0 && (
                        <tr>
                          <td>Firma/en</td>
                          <td>
                            {
                              data.firmen.map((item) => {
                                return (<Link href={window.location.origin + "/view-betrieb/" + item.id}>{item.name},</Link>)
                              })
                            }
                          </td>
                        </tr>
                      )
                    }
                    <tr>
                      <td>Punktekonto</td>
                      <td>{data.punkte} Punkt/e</td>
                    </tr>
                    
                    
                    {
                      data.mitarbeiterbei.length > 0 && (
                        <tr>
                          <td>Mitarbeiter bei</td>
                          <td>
                            {
                              data.mitarbeiterbei.map((item) => {
                                return (<Link href={window.location.origin + "/view-betrieb/" + item.id}>{item.name},</Link>)
                              })
                            }
                          </td>
                        </tr>
                      )
                    }
                    {
                      data.gruppen.length > 0 && (
                        <tr>
                          <td>Funktionen</td>
                          <td>{
                            data.gruppen.map((item) => {
                              return (<Typography>{item},</Typography>)
                            })
                          }</td>
                        </tr>


                      )
                    }
                    <tr>
                      <td>Regionalgruppe</td>
                      <td>{data.regionalgruppe}</td>
                    </tr>
                      
                    
                    {
                      data.tel != "" && (
                        <tr>
                          <td>Telefon</td>
                          <td>{data.tel}</td>
                        </tr>
                      )
                    }
                    {
                      data.geburtztdatum != "01.01.1970 01:00:00" && (
                        <tr>
                          <td>Geburtztdatum</td>
                          <td>{data.geburtztdatum.split(" ")[0]}</td>
                        </tr>
                      )
                    }
                    {
                      data.qualifikation != "" && (
                        <tr>
                          <td>Qualifikation</td>
                          <td>{data.qualifikation}</td>
                        </tr>
                      )
                    }
                    {
                      data.website != "" && (
                        <tr>
                          <td>Website</td>
                          <td>{data.website}</td>
                        </tr>
                      )
                    }
                    {
                      data.fax != "" && (
                        <tr>
                          <td>Fax</td>
                          <td>{data.fax}</td>
                        </tr>
                      )
                    }
                    {
                      data.vermögenshp != "" && (
                        <tr>
                          <td>Vermögenshaftpflicht bei</td>
                          <td>{data.vermögenshp}</td>
                        </tr>
                      )
                    }
                    {
                      data.vermögenshpsumme != "" && (
                        <tr>
                          <td>vermögenshafpflichtsumme</td>
                          <td>{data.vermögenshpsumme}</td>
                        </tr>
                      )
                    }
                    {
                      data.finanzvermittlernummer != "" && (
                        <tr>
                          <td>Finanzanlagenvermittlerregisternummer</td>
                          <td>{data.finanzvermittlernummer}</td>
                        </tr>
                      )
                    }
                    {
                      data.vermittlerregnummer != "" && (
                        <tr>
                          <td>Versicherungsvermittlerregisternummer</td>
                          <td>{data.vermittlerregnummer}</td>
                        </tr>
                      )
                    }
                    {
                      data.aufsichtsbehörde != "" && (
                        <tr>
                          <td>Aufsichtsbehörde</td>
                          <td>{data.aufsichtsbehörde}</td>
                        </tr>
                      )
                    }
                    {
                      data.identifikationsnummer != "" && (
                        <tr>
                          <td>Versicherungsvermittleridentifikationsnummer</td>
                          <td>{data.identifikationsnummer}</td>
                        </tr>
                      )
                    }
                    {
                      data.bafin != 0 && (
                        <tr>
                          <td>Bundesanstalt (Bafin)</td>
                          <td>{data.bafin ? "ja" : "Nein"}</td>
                        </tr>
                      )
                    }
                    {
                      data.ombudsman != 0 && (
                        <tr>
                          <td>Vers. Ombudsmann</td>
                          <td>{data.ombudsman ? "ja" : "Nein"}</td>
                        </tr>
                      )
                    }
                    {
                      data.ombudsmanpkw != 0 && (
                        <tr>
                          <td>Vers. Ombudsmann PKV</td>
                          <td>{data.ombudsmanpkw ? "ja" : "Nein"}</td>
                        </tr>
                      )
                    }
                    {
                      data.zentralregister != 0 && (
                        <tr>
                          <td>Zentralregister DBJK</td>
                          <td>{data.zentralregister ? "ja" : "Nein"}</td>
                        </tr>
                      )
                    }
                    {
                      data.eufreitext != "" && (
                        <tr>
                          <td>Eu Freitext</td>
                          <td>{data.eufreitext}</td>
                        </tr>
                      )
                    }
                  </tbody>
                </Table>
                {
                  id == "--" && (
                    <Button onClick={() => putedit()} sx={{ width: "10%" }}>
                      Bearbeiten
                    </Button>
                  )
                }

              </Card>
            )
          }
          {
            editmode && (
              <Card sx={{ p: 3, gap: 2, display: 'flex', flexDirection: 'column', width: "100%" }}>
                <FormControl>
                  <FormLabel>Geburtstag</FormLabel>
                  <Input
                    type="date"
                    value={geburtztag ? new Date(geburtztag).toISOString().split('T')[0] : ''}
                    onChange={(e) => {
                      const val = e.target.value;
                      setGeburtztag(val ? new Date(val).getTime() : null);
                    }}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Telefon</FormLabel>
                  <Input value={telefon} onChange={(e) => setTelefon(e.target.value)} />
                </FormControl>

                <FormControl>
                  <FormLabel>Beruf</FormLabel>
                  <Input value={beruf} onChange={(e) => setBeruf(e.target.value)} />
                </FormControl>

                <FormControl>
                  <FormLabel>Fax</FormLabel>
                  <Input value={fax} onChange={(e) => setFax(e.target.value)} />
                </FormControl>

                <FormControl>
                  <FormLabel>Webseite</FormLabel>
                  <Input value={web} onChange={(e) => setWeb(e.target.value)} />
                </FormControl>

                <FormControl>
                  <FormLabel>Qualifikation</FormLabel>
                  <Textarea
                    minRows={3}
                    value={qualifikation}
                    onChange={(e) => setQualifikation(e.target.value)}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Vermögenshaftpflicht</FormLabel>
                  <Input value={vermoegenhp} onChange={(e) => setVermoegenhp(e.target.value)} />
                </FormControl>

                <FormControl>
                  <FormLabel>Vermögenshaftpflicht-Summe</FormLabel>
                  <Input value={vermoegenhpsumme} onChange={(e) => setVermoegenhpsumme(e.target.value)} />
                </FormControl>

                <FormControl>
                  <FormLabel>Vermittlerregisternummer</FormLabel>
                  <Input value={vermittlerregnummer} onChange={(e) => setVermittlerregnummer(e.target.value)} />
                </FormControl>

                <FormControl>
                  <FormLabel>Finanzvermittlernummer</FormLabel>
                  <Input value={finanzvermittlernummer} onChange={(e) => setFinanzvermittlernummer(e.target.value)} />
                </FormControl>

                <FormControl>
                  <FormLabel>Aufsichtsbehörde</FormLabel>
                  <Textarea minRows={3} value={aufsichtsbehoerde} onChange={(e) => setAufsichtsbehoerde(e.target.value)} />
                </FormControl>

                <FormControl>
                  <FormLabel>Identifikationsnummer</FormLabel>
                  <Input value={identifikationsnummer} onChange={(e) => setIdentifikationsnummer(e.target.value)} />
                </FormControl>

                <FormControl>
                  <Checkbox sx={{ mt: 1 }} checked={bafin} onChange={(e) => setBafin(e.target.checked)} label="BaFin registriert" />
                  <Checkbox sx={{ mt: 1 }} checked={ombudsman} onChange={(e) => setOmbudsman(e.target.checked)} label="Ombudsmann" />
                  <Checkbox sx={{ mt: 1 }} checked={ombudsmannpkw} onChange={(e) => setOmbudsmannpkw(e.target.checked)} label="Ombudsmann PKV" />
                  <Checkbox sx={{ mt: 1 }} checked={zentralregister} onChange={(e) => setZentralregister(e.target.checked)} label="Zentralregister" />
                </FormControl>

                <FormControl>
                  <FormLabel>EU Freitext</FormLabel>
                  <Textarea
                    placeholder="Freitext"
                    minRows={4}
                    value={freitext}
                    onChange={(e) => setFreitext(e.target.value)}
                  />
                </FormControl>

                <Button onClick={() => save()} sx={{ width: "10%" }}>
                  Speichern
                </Button>
              </Card>
            )
          }
        </Box>




      </Box>
      <NavigationBar state={"profile"} />
    </>
  )
}

export default MyProfile
